import { render, staticRenderFns } from "./index.vue?vue&type=template&id=dda52efe&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda52efe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dda52efe')) {
      api.createRecord('dda52efe', component.options)
    } else {
      api.reload('dda52efe', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=dda52efe&scoped=true", function () {
      api.rerender('dda52efe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/functionModule/sysconfig/index.vue"
export default component.exports